import { createSlice } from "@reduxjs/toolkit";

const defaultMetadata = {
  disableBackdropClose: false,
  customStyles: {},
};

/** Build a single stack entry from openModal payload */
const makeStackEntry = (payload) => ({
  type: payload.type,
  data: payload.data ?? null,
  formData: payload.formData ?? {},
  step: payload.step ?? 1,
  stepState: {},
  metadata: {
    ...defaultMetadata,
    ...(payload.metadata || {}),
  },
});

const initialState = {
  stack: [],
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.stack.push(makeStackEntry(action.payload));
    },
    closeModal: (state) => {
      if (state.stack.length > 0) {
        state.stack.pop();
      }
    },
    closeAllModals: (state) => {
      state.stack = [];
    },
    // Payload may be a partial object (merge) or (prev) => partial (merge updater(prev)).
    updateFormData: (state, action) => {
      const top = state.stack[state.stack.length - 1];
      if (top) {
        const payload = action.payload;
        const next =
          typeof payload === "function"
            ? payload(top.formData)
            : payload;
        top.formData = { ...top.formData, ...next };
      }
    },
    setStep: (state, action) => {
      const top = state.stack[state.stack.length - 1];
      if (top) {
        top.step = action.payload;
      }
    },
    updateStepState: (state, action) => {
      const top = state.stack[state.stack.length - 1];
      if (top) {
        top.stepState = { ...top.stepState, ...action.payload };
      }
    },
    updateModalMetadata: (state, action) => {
      const top = state.stack[state.stack.length - 1];
      if (top) {
        top.metadata = { ...top.metadata, ...action.payload };
      }
    },
  },
});

export const {
  openModal,
  closeModal,
  closeAllModals,
  updateFormData,
  setStep,
  updateStepState,
  updateModalMetadata,
} = modalSlice.actions;

export default modalSlice.reducer;
